function freezeOptions(options) {
  return Object.freeze(options.map((option) => Object.freeze(option)));
}

export const SECOND_LIFE_STATUS_OPTIONS = freezeOptions([
  { value: "second-life", label: "Second Life", description: "I have a Second Life avatar." },
  { value: "not-second-life", label: "Not Second Life", description: "I am joining without a Second Life avatar." },
]);

export const TIME_ZONE_OPTIONS = freezeOptions([
  { value: "", label: "Choose a time zone" },
  { value: "UTC", label: "UTC — Coordinated Universal Time" },
  { value: "America/New_York", label: "Eastern Time — New York" },
  { value: "America/Chicago", label: "Central Time — Chicago" },
  { value: "America/Denver", label: "Mountain Time — Denver" },
  { value: "America/Los_Angeles", label: "Pacific Time — Los Angeles" },
  { value: "America/Anchorage", label: "Alaska Time — Anchorage" },
  { value: "Pacific/Honolulu", label: "Hawaii Time — Honolulu" },
  { value: "America/Halifax", label: "Atlantic Time — Halifax" },
  { value: "America/Sao_Paulo", label: "Brasília Time — São Paulo" },
  { value: "Europe/London", label: "United Kingdom — London" },
  { value: "Europe/Berlin", label: "Central Europe — Berlin" },
  { value: "Europe/Athens", label: "Eastern Europe — Athens" },
  { value: "Africa/Johannesburg", label: "South Africa — Johannesburg" },
  { value: "Asia/Dubai", label: "Gulf Time — Dubai" },
  { value: "Asia/Kolkata", label: "India Time — Kolkata" },
  { value: "Asia/Singapore", label: "Singapore Time" },
  { value: "Asia/Tokyo", label: "Japan Time — Tokyo" },
  { value: "Australia/Perth", label: "Western Australia — Perth" },
  { value: "Australia/Sydney", label: "Eastern Australia — Sydney" },
  { value: "Pacific/Auckland", label: "New Zealand — Auckland" },
]);

export const SECOND_LIFE_INTEREST_OPTIONS = freezeOptions([
  { value: "gaming", label: "Gaming" },
  { value: "trading", label: "Trading" },
  { value: "clubbing", label: "Clubbing" },
  { value: "sim-hopping", label: "Sim hopping" },
]);

export const GENERAL_INTEREST_OPTIONS = freezeOptions([
  { value: "gaming", label: "Gaming" },
  { value: "trading", label: "Trading" },
  { value: "community", label: "Community" },
  { value: "events", label: "Events" },
]);

export const GENDER_IDENTITY_OPTIONS = freezeOptions([
  { value: "male", label: "Male" },
  { value: "female", label: "Female" },
  { value: "transgender", label: "Trans / transgender" },
  { value: "prefer-not-to-identify", label: "Prefer not to identify" },
]);
